<template>
	<page>
		<module enable-flex ref="view">
			<m-search ref="search" @search="searchHandle">
				<c-form ref="searchForm">
					<c-form-item type="hidden" name="stationed_id"></c-form-item>
					<c-form-item type="input" label="所属商家" name="company_name" readonly @click="$refs.stationedSelector.open()"></c-form-item>
					<c-form-item type="input" label="收支记录号" name="record_number"></c-form-item>
					<c-form-item type="input" label="业务流水号" name="turnover_number"></c-form-item>
					<c-form-item type="input" label="摘要" name="remark"></c-form-item>
					<c-form-item type="select" label="收支类型" name="record_type" :options="recordType"></c-form-item>
					<c-form-item type="select" label="收付类型" name="turnover_type" :options="turnoverType"></c-form-item>
					<c-form-item type="select" label="业务类型" name="business_type" :options="businessType"></c-form-item>
					<c-form-item type="datetime" label="交易时间" start-name="begin_time" end-name="end_time"></c-form-item>
				</c-form>
			</m-search>
			
			<m-operate>
<!--				<c-button color="sys" power="b_stationed_account_record_export"  @click="exportJob()">导出</c-button>-->
                 <c-button color="m" hollow @click="syncExport()">导出</c-button>

                 <template #right>
                     <c-button v-if="userInfo.id == 1" color="red" @click="$refs.view.editExportColumn(workType)">编辑导出列</c-button>
                 </template>
             </m-operate>
			
			<c-table ref="table">
                <c-table-column type="selector"></c-table-column>

                <c-table-column
					label="收支记录号"
					name="record_number"
					width="150"
				></c-table-column>
				
				<c-table-column
					label="商家"
					name="stationed_name"
					width="160"
				></c-table-column>
				
				<c-table-column
					label="交易摘要"
					name="remark"
					width="280"
				></c-table-column>

				<c-table-column
					label="交易时间"
					name="create_date"
					width="150"
				></c-table-column>
				
				<c-table-column
					label="收支类型"
					name="record_type"
					width="80"
				>
				</c-table-column>
				
				<c-table-column
					label="交易金额"
					name="money"
					width="80"
				></c-table-column>
				
				<c-table-column
					label="余额"
					width="80"
					name="surplus_money"
				></c-table-column>
				
				<c-table-column
					label="待结算金额"
					width="100"
					name="settle_amount"
				></c-table-column>
				
				<c-table-column
					label="业务流水号"
					name="turnover_number"
					width="140"
				></c-table-column>
				
				<c-table-column
					label="业务单号"
					name="business_number"
					width="140"
				></c-table-column>
				
				<c-table-column
					label="收付类型"
					name="turnover_type"
					width="80"
				></c-table-column>
				
				<c-table-column
					label="业务类型"
					width="80"
					name="business_type"
				>
					<template v-slot="{data}">
						{{businessTypeName[data.business_type]}}
					</template>
				</c-table-column>
				
				<c-table-column
					type="button"
					fixed="right"
					label="操作"
					width="80"
				>
					<template v-slot="{data}">
						<c-table-button @click="navigateTo(`/stationed_account_record_detail/${data.id}`)">详情</c-table-button>
					</template>
				</c-table-column>
			</c-table>
		</module>
		<stationed-selector ref="stationedSelector" @resolve="selectStationed"></stationed-selector>
	</page>
</template>

<script>
	import stationedSelector from '@/components/service/stationed_selector.vue'
    import {mapState} from "vuex";  // 商家库
	export default {
		name: 'm_stationed_account_record',
		
		// 第二步：定义组件，导入了哪些就定义哪些
		components: {
			stationedSelector
		},
		
		props: {
			stationed_id: String,
			company_name: String
		},
		
		data() {
			return {
                workType:11,
                searchParams:{},
				recordTypeName:{
					'收款': '收款',
					'付款': '付款'
				},
				recordType: [{
						name: '收款',
						value: "收款"
					},{
						name: '付款',
						value: "付款"
					}
				],
				turnoverType: [{
						name: '待结算',
						value: "待结算"
					},{
						name: '结算',
						value: "结算"
					},{
						name: '取消结算',
						value: "取消结算"
					},{
						name: '退款',
						value: "退款"
					},{
						name: '提现',
						value: "提现"
					},{
						name: '补款',
						value: "补款"
					},{
						name: '扣款',
						value: "扣款"
					}
				],
				businessType: [{
					name: '销售订单',
					value: "1"
				},{
					name: '销售退款单',
					value: "2"
				},{
					name: '销售退货单',
					value: "3"
				},{
					name: '资金充值',
					value: "4"
				},{
					name: '资金扣减',
					value: "5"
				},{
					name: '资金提现',
					value: "6"
				}],
				businessTypeName :{
					1:'销售订单',
					2:'销售退款单',
					3:'销售退货单',
					4:'资金充值',
					5:'资金扣减',
					6:'资金提现'
				}
			}
		},
		
		computed: {
            ...mapState(['systemConfig', 'userInfo']),

            params() {
				return {
					stationed_id: this.stationed_id,
					company_name: this.company_name
				}
			}
		},
		
		watch: {
			params() {
				this.$refs.searchForm.clear();
				this.$refs.searchForm.set(this.params);
				this.$nextTick(() => {
					this.$refs.search.search();
				})
			}
		},
		
		mounted() {
			this.$refs.searchForm.set(this.params);
			this.$nextTick(() => {
				this.$refs.search.search();
			})
		},
		
		methods: {
			searchHandle(data) {
				data.stationed_type = 1;
				this.searchDate = data;
				this.$refs.table.load({
					url: '/stationed/account/record/list',
					data
				});
                this.searchParams = data||{};
			},
			exportJob() {
                var data = this.searchDate;
                data.job_id = 16;
				this.request({
					url: '/export_job/add',
					data: data,
					loading: true,
					success: data => {
						this.$message({
							text: '导出任务提交成功，请稍后前往任务中心查看',
							icon: 'success'
						});
					}
				});
			},
			selectStationed(data) {
				this.$refs.searchForm.set({
					stationed_id: data[0].id,
					company_name: data[0].company_name
				});
			},
            /**同步导出数据*/
            syncExport(){
                var selectDatas = this.$refs.table.getRow('selected');
                var ids = [];
                if (selectDatas.length && selectDatas.length>0) {
                    ids = Array.from(selectDatas, item => item.data.id);
                }
                this.export(this.workType,this.searchParams,ids);
            },
		}
	}
</script>